const toLower = (str) =>
  str ? str.trim().replace(/ +/g, '').toLowerCase() : '';
export default toLower;
